import React from 'react';
import {Flex, Box} from '@spothero/ui';
import PropTypes from 'prop-types';
import ReservationUtils from 'utils/reservation-utils';

const MobileTabs = ({
    activeTab,
    onToTopClick,
    onGettingThereClick,
    onInstructionsClick,
}) => {
    const baseTabStyles = {
        padding: 3,
        flex: '1',
        textAlign: 'center',
        fontSize: 'base',
        color: 'text.secondary.light',
        borderTopWidth: '2px',
        borderTopColor: 'gray.medium',
    };

    const activeTabStyles = {
        ...baseTabStyles,
        color: 'text.link.light',
        borderTopColor: 'text.link.light',
        fontWeight: 'semibold',
    };

    return (
        <Flex
            backgroundColor="white"
            position="fixed"
            bottom="0"
            width="100%"
            zIndex="layer6"
        >
            <Box
                {...(activeTab === ReservationUtils.ACTIVE_TAB_VALUES.PASS
                    ? activeTabStyles
                    : baseTabStyles)}
                onClick={onToTopClick}
            >
                Pass
            </Box>
            <Box
                {...(activeTab === ReservationUtils.ACTIVE_TAB_VALUES.DETAILS
                    ? activeTabStyles
                    : baseTabStyles)}
                onClick={onGettingThereClick}
            >
                Details
            </Box>
            <Box
                {...(activeTab === ReservationUtils.ACTIVE_TAB_VALUES.HOW_TO
                    ? activeTabStyles
                    : baseTabStyles)}
                onClick={onInstructionsClick}
            >
                How To
            </Box>
        </Flex>
    );
};

MobileTabs.propTypes = {
    activeTab: PropTypes.oneOf(
        Object.values(ReservationUtils.ACTIVE_TAB_VALUES)
    ),
    onToTopClick: PropTypes.func.isRequired,
    onGettingThereClick: PropTypes.func.isRequired,
    onInstructionsClick: PropTypes.func.isRequired,
};

export default MobileTabs;
